import React, {Component} from 'react';
import Select from "react-select";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import MomentUtils from '@date-io/moment';
import {MuiPickersUtilsProvider, KeyboardDatePicker} from '@material-ui/pickers';

import classes from './ReleasesInput.module.css';
import moment from "moment";

class ReleasesInput extends Component  {
    state = {
        game_releases: []
    };

    componentDidMount() {
        this.setState({game_releases: this.props.gameReleases});
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps !== this.props) {
            this.setState({game_releases: this.props.gameReleases});
        }
    }

    addGameRelease = () => {
        this.setState(
            {game_releases: [
                    ...this.state.game_releases,
                    {
                        game_release_id: null,
                        game_release_date: moment(Date()).format('YYYY-MM-DD'),
                        game_release_type: "",
                        game_release_notes: "",
                        game_release_name: ""
                    }]
            });
    };

    render() {
        let releasesInputElement = null;

        if (this.state.game_releases && this.state.game_releases.length) {
            let releases_index = 0;
            let releases = [...this.state.game_releases];
            releasesInputElement = (
                <>
                    <dd className="col-sm-9">
                        {releases.map(release => {
                            let releases_index_local = releases_index;
                            const return_jsx = (
                                <div className={classes.releaseBlock} key={releases_index_local}>
                                    <div className={classes.releaseTypeField}>
                                        <Select
                                            options={[
                                                {value: 'Primary', label: 'Primary'},
                                                {value: 'DLC', label: 'DLC'},
                                                {value: 'Expansion', label: 'Expansion'},
                                                {value: 'Remake', label: 'Remake'},
                                                {value: 'Remaster', label: 'Remaster'},
                                                {value: 'Enhanced Edition', label: 'Enhanced Edition'},
                                                {value: 'Special Edition', label: 'Special Edition'},
                                                {value: 'Regional Edition', label: 'Regional Edition'},
                                                {value: 'Port', label: 'Port'},
                                            ]}
                                            defaultValue={{value: release.game_release_type, label: release.game_release_type}}
                                            onChange={(event) => {
                                                let releases_local = [...releases];
                                                releases_local[releases_index_local] = {
                                                    game_release_id: releases_local[releases_index_local].game_release_id,
                                                    game_release_date: releases_local[releases_index_local].game_release_date,
                                                    game_release_type: event.value,
                                                    game_release_notes: releases_local[releases_index_local].game_release_notes,
                                                    game_release_name: releases_local[releases_index_local].game_release_name
                                                };
                                                this.setState({game_releases: releases_local});
                                                this.props.releasesUpdate(releases_local);
                                            }}
                                            closeMenuOnSlelect={true}
                                        />
                                        <MuiPickersUtilsProvider utils={MomentUtils}>
                                            <KeyboardDatePicker
                                                variant="inline"
                                                format="MM/DD/yyyy"
                                                margin="normal"
                                                id="date-picker-inline"
                                                label="Date picker inline"
                                                value={release.game_release_date}
                                                onChange={(date) => {
                                                    let releases_local = [...releases];
                                                    releases_local[releases_index_local] = {
                                                        game_release_id: releases_local[releases_index_local].game_release_id,
                                                        game_release_date: moment(date).format('YYYY-MM-DD'),
                                                        game_release_type: releases_local[releases_index_local].game_release_type,
                                                        game_release_notes: releases_local[releases_index_local].game_release_notes,
                                                        game_release_name: releases_local[releases_index_local].game_release_name
                                                    };
                                                    this.setState({game_releases: releases_local});
                                                    this.props.releasesUpdate(releases_local);
                                                }}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </div>
                                    <div className={classes.deleteRelease}>
                                        <Button className={classes.deleteReleaseButton} size="sm" variant={"outline-danger"} onClick={() => {
                                            let filtered_array = releases.filter((value,index,array) => {
                                                return index !== (releases_index_local)
                                            });

                                            this.setState({game_releases: filtered_array});
                                            this.props.releasesUpdate(filtered_array);
                                        }}>X</Button>
                                    </div>
                                    <div className={classes.gameRelease}>
                                        <Form.Control
                                            as="textarea"
                                            rows="1"
                                            placeholder="Input the release name here."
                                            value={release.game_release_name}
                                            onChange={(event) => {
                                                let releases_local = [...releases];
                                                releases_local[releases_index_local] = {
                                                    game_release_id: releases_local[releases_index_local].game_release_id,
                                                    game_release_date: releases_local[releases_index_local].game_release_date,
                                                    game_release_type: releases_local[releases_index_local].game_release_type,
                                                    game_release_notes: releases_local[releases_index_local].game_release_notes,
                                                    game_release_name: event.target.value
                                                };
                                                this.setState({game_releases: releases_local});
                                                this.props.releasesUpdate(releases_local);
                                            }}/>
                                    </div>
                                    <div className={classes.gameRelease}>
                                        <Form.Control
                                            as="textarea"
                                            rows="1"
                                            placeholder="Notes on the game release."
                                            value={release.game_release_notes}
                                            onChange={(event) => {
                                                let releases_local = [...releases];
                                                releases_local[releases_index_local] = {
                                                    game_release_id: releases_local[releases_index_local].game_release_id,
                                                    game_release_date: releases_local[releases_index_local].game_release_date,
                                                    game_release_type: releases_local[releases_index_local].game_release_type,
                                                    game_release_notes: event.target.value,
                                                    game_release_name: releases_local[releases_index_local].game_release_name
                                                };
                                                this.setState({game_releases: releases_local});
                                                this.props.releasesUpdate(releases_local);
                                            }}/>
                                    </div>
                                </div>
                            );
                            releases_index++;

                            return return_jsx;
                        })}
                    </dd>
                    <dt className="col-sm-3"> </dt>
                </>
            );
        }

        return (
            <dl className="row">
                <dt className="col-sm-3"><label>Releases:</label></dt>
                {releasesInputElement}
                <dd className="col-sm-9"><Button className="col-sm-12" variant="outline-primary" onClick={this.addGameRelease}>Add Release</Button></dd>
            </dl>
        );
    }
}

export default ReleasesInput;